import { request } from '@/api/common'
import apis from '@/common/config/host'

const GET_R_COUPON_LIST = apis.cApiDomain + '/coupon/rCouponList' // 等接口

export const getRCoupons = function (data) {
  return request.post(GET_R_COUPON_LIST, data)
}
